function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { Form, Input, Button, Image, Space, Skeleton, Drawer, InputNumber, Modal, Upload } from "antd";
import Common from "../components/includes/Common";
import { PencilFill, TrashFill, Upload as UploadIc, LockFill } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var Signature = function Signature() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    signature = _useState2[0],
    setSignature = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showNewSignature = _useState8[0],
    setShowNewSignature = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showChangePin = _useState0[0],
    setShowChangePin = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    file = _useState10[0],
    setFile = _useState10[1];
  var handleBlocSignature = function handleBlocSignature(s) {
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Voulez-vous vraiment"
      }),
      content: /*#__PURE__*/_jsx("p", {
        children: "Suspendre l'utilisation de votre signature ?"
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "/blocksignature", {}).then(function (response) {
          if (response.data.status == 200) {}
        })["catch"](function (error) {})["finally"](function () {});
      }
    });
  };
  var handleDeleeteSignature = function handleDeleeteSignature(s) {
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Voulez-vous vraiment"
      }),
      content: /*#__PURE__*/_jsx("p", {
        children: "Suprimer votre signature ?"
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "/deletesignature", {}).then(function (response) {
          if (response.data.status == 200) {}
        })["catch"](function (error) {})["finally"](function () {});
      }
    });
  };
  var onNewSignFinish = function onNewSignFinish(values) {};
  var onEditPinFinish = function onEditPinFinish(values) {};
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  useEffect(function () {
    setIsDataLoading(true);
    axios.get("".concat(Common.baseApiUrl, "getusersignature/").concat(Common.currentUser.id)).then(function (response) {
      if (response.data.status == 200) {
        //setSignature(response.data.signature);  
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 4,
          md: 5,
          sm: 12,
          children: [isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
            active: true
          }), (!null ? /*#__PURE__*/_jsx(Image, {
            preview: false,
            src: signature.file,
            placeholder: /*#__PURE__*/_jsx("div", {
              style: {
                color: "#625C57",
                textAlign: "center"
              },
              children: /*#__PURE__*/_jsx("h4", {
                children: "AUCUNE SIGNATURE"
              })
            })
          }) : /*#__PURE__*/_jsx("div", {
            style: {
              color: "#625C57",
              textAlign: "center"
            },
            children: /*#__PURE__*/_jsx("h4", {
              children: "AUCUNE SIGNATURE"
            })
          }), _readOnlyError("signature"))]
        }), /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          sm: 12,
          children: /*#__PURE__*/_jsxs(Space, {
            direction: "vertical",
            children: [/*#__PURE__*/_jsx(Button, {
              type: "link",
              onClick: function onClick() {
                setShowNewSignature(true);
              },
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(PencilFill, {
                  size: 20
                }), " CHOISIR UNE SIGNATURE"]
              })
            }), /*#__PURE__*/_jsx(Button, {
              type: "link",
              disabled: signature == null,
              onClick: function onClick() {
                handleBlocSignature(signature);
              },
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(LockFill, {
                  size: 20
                }), " BLOQUER"]
              })
            }), /*#__PURE__*/_jsx(Button, {
              type: "link",
              disabled: signature == null,
              onClick: function onClick() {
                handleDeleeteSignature(signature);
              },
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(TrashFill, {
                  size: 20
                }), " SUPRIMER"]
              })
            }), /*#__PURE__*/_jsx(Button, {
              type: "link",
              disabled: signature == null,
              onClick: function onClick() {
                setShowChangePin(true);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: "CHANGER LE PIN"
              })
            })]
          })
        })]
      })
    }), signature != null && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(Modal, {
        open: showChangePin,
        onCancel: function onCancel() {
          setShowChangePin(false);
        },
        footer: null,
        width: "600px",
        destroyOnClose: true,
        title: /*#__PURE__*/_jsx("b", {
          children: "MODIFIER LE SIGN PIN"
        }),
        children: [/*#__PURE__*/_jsx(Form, {
          onFinish: onEditPinFinish,
          layout: "vertical",
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "pin",
            label: "D\xE9finir un code pin pour la s\xE9curit\xE9",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {})
          })
        }), /*#__PURE__*/_jsx(Form.Item, {
          children: /*#__PURE__*/_jsx(Button, {
            type: "link",
            htmlType: "submit",
            children: /*#__PURE__*/_jsx("b", {
              children: "VALIDER"
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Modal, {
      open: showNewSignature,
      onCancel: function onCancel() {
        setShowNewSignature(false);
      },
      footer: null,
      width: "600px",
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "CHOISIR VOTRE SIGNATURE"
      }),
      children: /*#__PURE__*/_jsxs(Form, {
        onFinish: onNewSignFinish,
        layout: "vertical",
        children: [/*#__PURE__*/_jsx(Form.Item, {
          name: "pin",
          label: "D\xE9finir un code pin pour la s\xE9curit\xE9",
          rules: [{
            required: true,
            message: "Ce champ est obligatoire"
          }],
          children: /*#__PURE__*/_jsx(InputNumber, {})
        }), /*#__PURE__*/_jsx(Form.Item, {
          label: " ",
          children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
            children: /*#__PURE__*/_jsx(Button, {
              type: "primary",
              icon: /*#__PURE__*/_jsx(UploadIc, {
                size: 20
              }),
              children: /*#__PURE__*/_jsx("b", {
                children: "JOINDRE LA SIGNATURE"
              })
            })
          }))
        }), /*#__PURE__*/_jsx(Form.Item, {
          children: /*#__PURE__*/_jsx(Button, {
            type: "link",
            htmlType: "submit",
            children: /*#__PURE__*/_jsx("b", {
              children: "CHOISIR"
            })
          })
        })]
      })
    })]
  });
};
export default Signature;